import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { BRANDS } from '../../util/constants';

// custom react-jsonschema-form field for multi BRAND select input
function ProdigyMultiSchemaField(props) {
  const { formData, formContext } = props;
  const [selectedBrands, setSelectedBrands] = useState([]);

  useEffect(() => {
    // If the dealer is independent, then the brand field should be empty
    if (formContext.isIndependent) {
      onSelectedBrandsChange([]);
      return;
    }
    if (formData) {
      setSelectedBrands(formData);
    }
  }, [formData, formContext]);

  const onSelectedBrandsChange = (value) => {
    setSelectedBrands(value);
    props.onChange(value);
  };

  return [
    <label key="label" className="control-label" htmlFor="brand-typeahead">
      Brands *
    </label>,
    <div key="input" className="input-group">
      <Typeahead
        id="brand-typeahead"
        className="picker brand-picker"
        placeholder="Brand"
        selectHintOnEnter
        multiple
        clearButton
        required
        disabled={!!formContext.isIndependent}
        options={BRANDS.sort((a, b) => b - a).map((y) => `${y}`)}
        selected={[].concat(selectedBrands)}
        onChange={onSelectedBrandsChange}
      />
    </div>,
  ];
}

ProdigyMultiSchemaField.propTypes = {
  formData: PropTypes.array,
  schema: PropTypes.object,
  onChange: PropTypes.func,
};

export default ProdigyMultiSchemaField;
